<button [disabled]="disabled" [class.has-text]="!!text">
    <icon *ngIf="icon" [name]="icon" class="optional-icon"></icon>
    <div *ngIf="text" class="text">{{text}}</div>
    <icon *ngIf="showArrow" name="arrow_right" class="arrow-icon"></icon>
</button>